'use strict'
import angular from 'angular';
import './instanceSettings.service';

angular.module('instanceSettings.services', [])
angular.module('instanceSettings', ['instanceSettings.services'])